<div class="card card-custom">
    <div class="card-body" *ngIf="!(loading$|async); else loading">
        <div class="row">
            <div class="col-md-12 kt-margin-bottom-20-mobile">
                <h5 class="my-3 text-mad text-uppercase">{{targetProperty.name}}</h5>
                <hr class="active" />
            </div>
        </div>
        <div class="row">
            <div class="col-xl-8 px-3">
                <kt-pictures-module-v2
                    [tpPictures]="targetProperty.pictures"
                    [buildingPictures]="targetProperty.buildingInfo.pictures"></kt-pictures-module-v2>
            </div>
            <div class="col-xl-4 px-3 milestone-valuation-wrapper">
                <div>
                    <div class="row">
                        <div class="col-xl-12">
                            <kt-milestone-module-v2
                                [viewModel]="mileStoneModuleData"></kt-milestone-module-v2>
                        </div>
                    </div>
                    <div class="row mt-6">
                        <div class="col-xl-12">
                            <kt-valuation-module-v2 [viewModel]="valuationModuleData"></kt-valuation-module-v2>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row mt-6">
            <div class="col-xl-4 px-3">
                <kt-team-involvement-module-v2 [viewModel]="teamInvolvementModuleData"></kt-team-involvement-module-v2>
            </div>
            <div class="col-xl-8 px-3">
                <kt-property-specifics-module-v2 [viewModel]="propertySpecificsModuleData"></kt-property-specifics-module-v2>
            </div>
        </div>
        <div class="row mt-6" *ngIf="fullTp.type_of_inspection != 1">
            <div class="col-xl-12 px-3">
                <kt-condition-ratin-module-v2
                    [targetProperty]="fullTp"
                    [tpDetails]="fullTp.details">
                </kt-condition-ratin-module-v2>
            </div>
        </div>
        <div class="row mt-6">
            <div class="col-xl-12 px-3">
                <kt-available-documents-module 
                    [toe]="toe" 
                    [targetProperty]="targetProperty"
                    [assignment]="assignment"
                    [workers]="workers"
                ></kt-available-documents-module> 
            </div>
        </div>

        <div class="row mt-6">
            <div class="col-xl-12 px-3">
                <kt-special-assumptions-module [targetProperty]="fullTp"></kt-special-assumptions-module>
            </div>
        </div>

        <div class="row mt-6">
            <div class="col-xl-12 px-3">
               <kt-notes-module [readonly]="readonly" [workers]="workers" [valuerUserId]="valuation.team.valuer.id" [currentUser]="currentUser"></kt-notes-module>
            </div>
        </div>
    </div>
</div>

<ng-template #loading>
    <div class="loading"></div>
</ng-template>